import { call, put } from 'redux-saga/effects';
import GetChildrenActions from '../redux/GetChildrenRedux';
import { api } from './api';

export function* getChildren(action: any): Generator<any, void, any> {
  // const { data } = action
  
  try {
    const response = yield call(api.getChildren);

    // success?
    if (response.ok) {
      // You might need to change the response here - do this with a 'transform',
      // located in ../Transforms/. Otherwise, just pass the data back from the api.
      yield put(GetChildrenActions.getChildrenSuccess(response?.data?.data));
    } else {
      // Pass error details including status code
      const errorDetails = {
        status: response.status,
        message: response.data?.message || 'Failed to fetch children',
        response: response
      };
      console.log('GetChildrenSaga: API call failed with error:', errorDetails);
      yield put(GetChildrenActions.getChildrenFailure(errorDetails));
    }
  } catch (error: any) {
    // Handle network or other errors
    const errorDetails = {
      status: error?.response?.status || 0,
      message: error?.message || 'Network error occurred',
      error: error
    };
    console.error('GetChildrenSaga: Exception occurred:', errorDetails);
    yield put(GetChildrenActions.getChildrenFailure(errorDetails));
  }
}
